import {
    createSelector,
} from 'reselect';

import {
    tripSelectors,
} from 'wanderu-ducks-trips';
import {
    createSelectorFactory,
} from 'wanderu-ducks-utils';

function selectItinerariesFactory(tripIds) {
    return createSelector(
        (appState) => appState,
        (appState) => tripSelectors.selectLegIds(appState, tripIds),
        (appState, legIds) => legIds.map(
            (legId) => tripSelectors.selectTripItinerary(appState, legId),
        ),
    );
}

const selectItineraries = createSelectorFactory(selectItinerariesFactory);

export {
    selectItineraries,
};
